import { render, staticRenderFns } from "./StopIcon.vue?vue&type=template&id=afecfea0&"
import script from "./StopIcon.vue?vue&type=script&lang=js&"
export * from "./StopIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports